import {createContext , useEffect, useState} from "react"
import Cookies from "universal-cookie"
import axios from "axios"
import { clearWonderPush, ensurePushSubscription, initWonderPush } from "../wonderpush"
import { getNotificationPermission } from "../notificationPermission"
import { clearSession, setSessionExpiredHandler } from "../session"

const AuthContext = createContext({})

export const AuthProvider = ({ children }) =>
{
    const cookies = new Cookies();
    const load = cookies.get('bezkoder-jwt-refresh'); 
    const [auth , setAuth]  = useState(load ? cookies.get('bezkoder-jwt-refresh') : null)



    const login = (loginAuth) => 
    {
        // cookies.set('bezkoder-jwt-refresh' , JSON.stringify(loginAuth['refersh_token']) ,  { path: '/'  , maxAge: 31536000})
        // axios.defaults.headers.common['Authorization'] = `Bearer ${loginAuth['access_token']}`;
      
    }
    const logout = async() =>
    {
        const refershToken = cookies.get('bezkoder-jwt-refresh')
        clearWonderPush()
        try {
            await axios.post('signout' , {"token":refershToken});
        } catch (err) { /* הסשן ינוקה מקומית בכל מקרה */ }
        clearSession()
        setAuth(null)
    }

    // פקיעת סשן = התנתקות. ה-interceptor מדווח לכאן במקום לנווט בעצמו,
    // כך שהעמוד שורד ופקודת הניתוק של WonderPush מספיקה לצאת.
    useEffect(() => {
        setSessionExpiredHandler(() => {
            clearWonderPush()
            clearSession()
            setAuth(null)
            // רשת ביטחון: מסכים שאינם מוגנים (למשל /Practice) לא מנווטים לבד כשה-auth מתאפס.
            // ההשהיה ארוכה בכוונה — אתחול קר של WonderPush לוקח זמן, ולא רוצים להרוג אותו באמצע.
            setTimeout(() => {
                if (!/^\/login\/?$/i.test(window.location.pathname)) {
                    window.location.href = '/'
                }
            }, 4000)
        })
    }, [])

    // מחבר את המשתמש ל-WonderPush בכל פעם שיש סשן חי + טוקן — ורק אם הרשאת ההתראות כבר ניתנה.
    // לא מבקש הרשאה אף פעם: הבקשה נעשית במקום אחד בלבד, במסך ה-Login, לפני setAuth.
    // אם ה-cookie אבד בזמן שהסשן שרד — הטוקן לא ניתן לשחזור בצד לקוח; הזיהוי יחזור ב-login הבא.
    useEffect(() => {
        const wpToken = cookies.get('wonderPush_token')
        if (auth && wpToken && getNotificationPermission() === 'granted') {
            initWonderPush(wpToken)
            // הדיאלוג האוטומטי של ה-SDK מנוטרל, לכן יוצרים/משחזרים את המנוי במפורש
            // (בלי שום חלון — ההרשאה כבר granted)
            ensurePushSubscription()
        }
    }, [auth])


    // const checkAuth = async () => {
    //     if (!accessToken) return;
    
    //     try {
    //       const response = await fetch("https://example.com/api/validate-token", {
    //         method: "POST",
    //         headers: { Authorization: `Bearer ${accessToken}` },
    //       });
    
    //       if (!response.ok) {
    //         // נסה לרענן את הטוקן
    //         const refreshResponse = await fetch("https://example.com/api/refresh-token", {
    //           method: "POST",
    //           credentials: "include", // שולח את ה-Refresh Token
    //         });
    
    //         if (refreshResponse.ok) {
    //           const data = await refreshResponse.json();
    //           login(data.accessToken); // שמור את הטוקן החדש
    //         } else {
    //           logout(); // אם רענון הטוקן נכשל, בצע יציאה
    //         }
    //       }
    //     } catch (error) {
    //       console.error("Error validating token:", error);
    //       logout();
    //     }
    //   };
    
    //   // אפקט שמוודא רענון הטוקן
    //   useEffect(() => {
    //     checkAuth();
    //   }, [accessToken]);


    return (
        <AuthContext.Provider value={{auth , setAuth , login , logout}}>
            {children} 
        </AuthContext.Provider>
    )
}
export default AuthContext;



// var today = new Date();
            // var nextSession = new Date() 
            // nextSession.setDate(today.getDate() + 100 );
            // cookies.set('jwt_authorization' , JSON.stringify(auth) ,  { path: '/'  , maxAge: 31536000} , 
            // {
            //     expires: nextSession
            // }
            // )